import Towary from "./towary";

(() => {
  if (typeof $ === "undefined") {
    throw new TypeError("... requires jQuery.");
  }

  $(document).ready(() => {
    const towary = new Towary();
    towary.init();
  });
})();
